import React from "react";

const PlusIcon = () => (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_8713_43382)">
            <path d="M15.2505 15.7399C12.5169 18.4735 8.0847 18.4735 5.35103 15.7399C2.61736 13.0062 2.61736 8.57404 5.35103 5.84037C8.0847 3.1067 12.5169 3.1067 15.2505 5.84037C17.9842 8.57404 17.9842 13.0062 15.2505 15.7399Z" fill="white" />
            <path d="M10.3008 8.31525V13.265M12.7757 10.7901H7.82591M15.2505 15.7399C12.5169 18.4735 8.0847 18.4735 5.35103 15.7399C2.61736 13.0062 2.61736 8.57404 5.35103 5.84037C8.0847 3.1067 12.5169 3.1067 15.2505 5.84037C17.9842 8.57404 17.9842 13.0062 15.2505 15.7399Z" stroke="#FAB317" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_8713_43382">
                <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
)

export default PlusIcon;